module.exports = __webpack_public_path__ + "media/KONTO_BANKOWE.828c8f7b.mp3";